module.exports = __webpack_public_path__ + "static/media/gut-balance.e56df38f.svg";